import { RoomToken } from 'features/room/types';
import { call, cancel, fork, select } from 'redux-saga/effects';
import { Task } from 'redux-saga';
import { selectRoomToken } from 'features/room/roomSlice';
import { stopRecorder } from 'features/recorder/utils';
import { extensionWatchdogSaga } from 'features/recorder/sagas/extensionWatchdogSaga';
import { SignalingSocket } from 'services/signaling';
import * as Sentry from '@sentry/react';
import { logger } from 'utils/logger';

export function* stopRecorderSaga() {
  try {
    const token: RoomToken = yield select(selectRoomToken);
    if (!token.parsedData) {
      throw new Error('Missing token data');
    }

    const { recordingId } = token.parsedData;
    const watchdog: Task = yield fork(extensionWatchdogSaga, 'stop', recordingId);

    try {
      yield call(stopRecorder, { recordingId: recordingId! });
    } finally {
      yield cancel(watchdog);
    }

    yield call(SignalingSocket.send, { event: 'recordingStopped' });
  } catch (error) {
    yield call(SignalingSocket.send, { event: 'recordingFailure' });

    Sentry.captureException(error, { tags: { feature: 'recorder' } });
    logger.remote({ tier: 1 }).error('Recording stop failed', error);
  }
}
